import { createColorVariable as r, createOutline as s } from "./highrise530.mjs";
function c(e) {
  let o = {
    color: "transparent",
    border: "none",
    textColor: r(e, 700),
    rippleColor: r(e, 600),
    // hover
    borderHover: "none",
    textColorHover: r(e, 800),
    colorHover: r(e, 50),
    // focus
    textColorFocus: r(e, 800),
    colorFocus: r(e, 50),
    outlineFocus: s(e, 100),
    borderFocus: "none",
    // pressed
    textColorPressed: r(e, 900),
    colorPressed: r(e, 100),
    borderPressed: "none",
    // disabled
    textColorDisabled: r(e, 300),
    colorDisabled: "transparent",
    borderDisabled: "none"
  };
  return e === "primary" && (o = {
    ...o,
    colorHover: r(e, 100),
    colorFocus: r(e, 100),
    colorPressed: r(e, 200)
  }), o;
}
export {
  c as createGhostTheme
};
